import axios from 'axios'

let authApi = axios.create({
  baseURL: '/termine/auth',
  headers: { 'content-type': 'application/x-www-form-urlencoded' },
})

export default {
  /** @deprecated	*/
  loginWithPassword(username, password) {
    const params = new URLSearchParams()
    params.append('grant_type', 'password')
    params.append('username', username)
    params.append('password', password)
    params.append(
      'scope',
      'openid oeamtc.membership.persons.personen.read oeamtc.emob.case.read oeamtc.emob.connect.read'
    )
    return authApi.post('/token', params)
  },
  getSessionData() {
    const params = new URLSearchParams()
    params.append('grant_type', 'ssoid')
    params.append('ssoid', 'XXX') // SSOID is set with Filter in Proxy
    params.append('scope', 'openid')
    return authApi.post('/token', params)
  },
  refreshSessionData(refreshToken) {
    const params = new URLSearchParams()
    params.append('grant_type', 'refresh_token')
    params.append('refresh_token', refreshToken)
    return authApi.post('/token', params)
  },
}
